export default __webpack_public_path__ + "static/media/logo.9996c86c.png";